export default "__VITE_ASSET__D4PIZ85j__"